/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ExportCommentsWidget_widget = {|
  +id: string;
  +type: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportCommentsWidget_widget",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "type",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "withWidgetData_widget",
      "args": null
    }
  ],
  "type": "Widget"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/components/ExportCommentsWidget/__generated__/ExportCommentsWidget_widget.graphql.js